import React from 'react';
import { useTranslation } from 'react-i18next';

import { StripeForm } from '../../common/stripe/StripeForm';
import Loading from '../../common/Loading';
import './PaymentMethod.css';

const LoadingStripe = () => <Loading border="5px" size="30px" />;

const PaymentMethod = ({
  containerRef = null,
  showError = false,
  stripeRef = null,
  email = '',
  name = '',
  phoneNumber = '',
}) => {
  const { t } = useTranslation('enrollment');
  return (
    <div
      ref={containerRef}
      className="Payment-method-section"
      id="paymentMethod"
    >
      <h1 className="Payment-method-title">{t('paymentMethod.title')}</h1>

      <StripeForm
        ref={stripeRef}
        email={email}
        Loading={LoadingStripe}
        name={name}
        phone={phoneNumber}
      />

      <span className="Payment-method-error-label" id="payment-method-error">
        {showError ? t('paymentMethod.required') : null}
      </span>
    </div>
  );
};

export { PaymentMethod };
